module.exports = __webpack_public_path__ + "static/media/isc.b6f94eea.png";